import React from 'react';
import logoOutlined from 'media/Logo/Frame 117.png';
import listEmptyImage from 'media/Logo/List is empty 1.svg';
import rLogo from 'media/Logo/®.svg';

const floatAnimation = `
  @keyframes float-fun {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    25% { transform: translateY(-10px) rotate(2deg); }
    75% { transform: translateY(5px) rotate(-2deg); }
  }
`;

const SplitAuthLayout = ({ children }) => {
  return (
    <div className='flex min-h-screen bg-white'>
      <style>{floatAnimation}</style>
      {/* Left Side - Black Background with White Text */}
      <div className='hidden lg:flex lg:w-1/2 bg-black flex-col justify-center items-center p-12 relative overflow-hidden'>
        <div className='flex flex-col items-center max-w-md text-center'>
          
          <img
            src={listEmptyImage}
            alt='Sportona Dashboard'
            className='object-contain drop-shadow-2xl w-3/4 max-w-[280px] mb-8 cursor-pointer'
            style={{ animation: 'float-fun 4s ease-in-out infinite' }}
          />

          <h1 className='text-white text-4xl font-bold mb-4 leading-tight'>
            Run your whole sports business from one place.
          </h1>
          <p className='text-gray-400 text-lg mb-8'>
            Bookings, experiences, payouts, and your team — together in a fast desktop console built for the work you do at your desk.
          </p>
          
          <div className='relative inline-block mb-8'>
            <img
              src={logoOutlined}
              alt='Sportona Logo'
              className='w-56'
            />
            <img 
              src={rLogo} 
              alt='Registered' 
              className='absolute -top-2 -right-6 w-6 h-6' 
            />
          </div>

        </div>
        <div className='absolute bottom-8 left-8 text-gray-500 text-sm'>
          Business Console · {new Date().getFullYear()}
        </div>

        {/* Store Icons */}
        <div className='absolute bottom-8 right-8 flex gap-3'>
          <a href="#" className='flex items-center gap-2 bg-[#1A1A1A] hover:bg-[#2A2A2A] transition-colors text-white px-3 py-1.5 rounded-lg border border-gray-800'>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.364 2.036c.636-1.164 1.764-1.928 2.728-2.036.145 1.455-.473 2.873-1.236 4.073-1.018 1.491-2.618 2.364-4 2.218-.182-1.382.509-2.8 1.509-4.255zM17.418 7.309c-1.891-.073-3.636 1.127-4.655 1.127-1.055 0-2.473-1.018-3.927-1.018-2.036 0-3.964 1.164-5.018 2.945-2.145 3.745-.545 9.273 1.527 12.255 1.018 1.491 2.218 3.164 3.855 3.127 1.564-.073 2.145-1.018 4.036-1.018 1.855 0 2.4.982 4.036.982 1.673.036 2.727-1.491 3.709-2.945 1.164-1.636 1.636-3.236 1.673-3.309-.036-.036-3.127-1.2-3.164-4.764-.036-2.982 2.436-4.4 2.545-4.473-1.382-2.036-3.527-2.327-4.618-2.327z"/>
            </svg>
            <div className='flex flex-col items-start'>
              <span className='text-[9px] leading-tight text-gray-300'>Download on the</span>
              <span className='text-[13px] font-semibold leading-tight'>App Store</span>
            </div>
          </a>
          
          <a href="#" className='flex items-center gap-2 bg-[#1A1A1A] hover:bg-[#2A2A2A] transition-colors text-white px-3 py-1.5 rounded-lg border border-gray-800'>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.5 2.5C3.2 2.7 3 3.1 3 3.7v16.7c0 .6.2 1 .5 1.2l.1.1 9.4-9.4v-.2L3.6 2.4l-.1.1zM13.4 12.5l2.9 2.9-1.9 1.1c-1.8 1-4.8 2.7-4.8 2.7l3.8-3.8v-.2zM13.4 11.5L9.6 7.7c0 0 3-1.7 4.8-2.7 1.2-.7 2-1.1 1.9-1.1l-2.9 2.9v.2zM16.6 10.7c.3.2.4.5.4.8s-.1.6-.4.8l-1.9 1.1-3-3 3-3 1.9 1.1z"/>
            </svg>
            <div className='flex flex-col items-start'>
              <span className='text-[9px] leading-tight text-gray-300'>GET IT ON</span>
              <span className='text-[13px] font-semibold leading-tight'>Google Play</span>
            </div>
          </a>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className='flex w-full lg:w-1/2 justify-center items-center p-8 bg-white'>
        <div className='w-full max-w-md'>
          {children}
        </div>
      </div>
    </div>
  );
};

export default SplitAuthLayout;
